import Feature from "ol/Feature";
import PointGeom from "ol/geom/Point";
import { Select } from "ol/interaction";
import { Vector as VectorLayer } from "ol/layer";
import { fromLonLat } from "ol/proj";
import { Cluster, Vector as VectorSource } from "ol/source";
import {
  Circle as CircleStyle,
  Fill,
  Stroke,
  Style,
  Text,
} from 'ol/style';

import {CouncelingCenterLayerObject} from "@/gis/GISApi";
import { layerStyles } from "@/gis/layer/styles";

export default class CouncelingCenterLayer extends VectorLayer<any> {
  private selectInteraction: Select;

  constructor() {
    const source = new VectorSource();

    const woman = document && document.body && document.body.classList.contains("frauen");
    const isHomeSite = document && document.body && document.body.classList.contains("is-home");

    const clusterLayerStyle = (size: number) => {
      if (woman) {
        return [
          new Style({
            image: new CircleStyle({
              radius: 18,
              stroke: new Stroke({
                color: '#870038',
                width: 2
              }),
              fill: new Fill({
                color: '#FFF',
              }),
            }),
            text: new Text({
              text: size.toString(),
              fill: new Fill({
                color: '#870038',
              }),
              font: 'bold 18px Roboto'
            }),
          }),
        ];
      } else {
        return [
          new Style({
            image: new CircleStyle({
              radius: 18,
              stroke: new Stroke({
                color: '#217cab',
                width: 2
              }),
              fill: new Fill({
                color: '#FFF',
              }),
            }),
            text: new Text({
              text: size.toString(),
              fill: new Fill({
                color: '#217cab',
              }),
              font: 'bold 18px Roboto'
            }),
          }),
        ];
      }
    }

    const clusterSource = new Cluster({
      distance: (isHomeSite ? 0 : 40),
      source: source,
    });

    const style = function() {
      return layerStyles["ccPin"];
    };

    const courtStyle = function() {
      return layerStyles["ccPinGericht"];
    };

    const clusterStyle = function(feature: any) {
      if (Array.isArray(feature.get('features'))) {
        const size = feature.get('features').length;
        if (size > 1) {
          if(isHomeSite) {
            if (feature.get('features').some((feature: Feature<PointGeom>) => { return feature.get('cCenter').isCourt })) {
              return courtStyle();
            } else {
              return style();
            }
          }
          return clusterLayerStyle(size);
        } else {
          // no cluster, only one or zero values
          if (feature.get('features').length == 1 && feature.get('features')[0].get('cCenter').isCourt) {
            return courtStyle();
          } else {
            return style();
          }

        }
      }
    }

    super({
      source: clusterSource,
      style: clusterStyle
    });

    this.selectInteraction = new Select({
      hitTolerance: 8,
      layers: [this],
      multi: false,
      style: function(feature: any) {
        if (Array.isArray(feature.get('features'))) {
          const size = feature.get('features').length;
          if (size == 1) {
            return layerStyles["selectedPin"];
          } else if (size > 1) {
            if(isHomeSite) {
              return layerStyles["selectedPin"];
            }
            return clusterLayerStyle(size);
          }
        }
      }
    });
  }

  public getSelectInteraction() {
    return this.selectInteraction;
  }

  public setCouncelingCenters(cCenters: CouncelingCenterLayerObject[]): void {
    this.removeCouncelingCenters();

    const features = cCenters.map(cCenter => {
      return new Feature({
        geometry: new PointGeom( fromLonLat([cCenter.longitude, cCenter.latitude]) ),
        cCenter
      });
    });

    (this as any).getSource().setSource(new VectorSource({
      features: features
    }))
  }

  removeCouncelingCenters(): void {
    (this as any).getSource().getSource().clear();
  }

  public selectCouncelingCenter(cCenter: CouncelingCenterLayerObject) {
    this.unselectCouncelingCenters();
    const feature = (this as any)
        .getSource()
        .getSource()
        .getFeatures()
        .filter((feature: any) => { return JSON.stringify(feature.get("cCenter")) === JSON.stringify(cCenter) });
// console.log("feature: " + feature.get("cCenter"))
// console.dir(feature)
    if (feature.length) {
        this.selectInteraction.getFeatures().push(feature[0]);
    }
  }

  unselectCouncelingCenters(): void{
    this.selectInteraction.getFeatures().clear();
  }
}
